import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9on71qftmtnfcfh0a90';

export default function About() {
  const location = useLocation();
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          [...formData.entries()]
            .filter(([key]) => key !== 'phone_alt')
            .map(([key, val]) => [key, String(val)])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后再试';
        if (String(msg).includes('spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(msg);
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请稍后再试');
      setFormStatus('error');
    }
  };

  const reputationItems = [
    { label: '精选韩漫', value: '500+', icon: 'ri-book-open-line' },
    { label: '日均访问', value: '50万+', icon: 'ri-user-line' },
    { label: '用户评分', value: '4.9', icon: 'ri-star-line' },
    { label: '更新频率', value: '每日', icon: 'ri-refresh-line' },
  ];

  const reviews = [
    {
      name: '小雨',
      text: '布丁漫画是我用过最好用的韩漫网站！下拉式阅读太方便了，而且更新超快，每次新话出来第一时间就能看到。韩漫推荐也很准，发现了好多宝藏作品。',
      rating: 5,
    },
    {
      name: '星辰大海',
      text: '作为一个韩漫重度爱好者，布丁漫画的分类和排行功能特别好用。恋爱韩漫和奇幻韩漫的分类很细，找漫画特别方便。最重要的是完全免费！',
      rating: 5,
    },
    {
      name: 'Alice',
      text: '界面简洁好看，没有乱七八糟的广告。韩漫的资源很全，画质也很清晰。下拉式阅读体验一流，看韩漫超级流畅。推荐给所有喜欢韩漫的朋友！',
      rating: 5,
    },
    {
      name: '漫画控',
      text: '布丁漫画的排行系统很客观，评分和人气榜跟我在韩国平台看到的趋势基本一致。韩漫推荐也很用心，每部漫画都有详细的介绍和评价。',
      rating: 4,
    },
    {
      name: '风之谷',
      text: '用布丁漫画快一年了，韩漫资源一直在增加，更新速度也很快。下拉式阅读模式是最棒的功能，手机上看韩漫体验特别好。希望能一直保持这个品质！',
      rating: 5,
    },
    {
      name: '月光泠泠',
      text: '朋友推荐的布丁漫画，一开始只是试试看，现在已经离不开啦！韩漫推荐的质量很高，每种类型的韩漫都有精选榜单。免费全集韩漫真的很良心。',
      rating: 5,
    },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</a>
              <span>/</span>
              <span className="text-foreground-900 font-medium whitespace-nowrap">关于我们</span>
            </div>

            <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-6">关于布丁漫画</h1>

            <div className="prose prose-sm max-w-none">
              <div className="bg-background-100 rounded-lg p-6 md:p-8 mb-8">
                <h2 className="text-xl font-heading text-foreground-900 mb-4">品牌介绍</h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  布丁漫画成立于2022年，是国内领先的韩漫推荐与排行平台。我们专注于为韩漫爱好者提供优质的免费韩漫阅读体验，精选热门韩漫推荐，提供实时韩漫排行，支持下拉式在线观看模式，让韩漫阅读更加流畅自然。
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  我们的团队由一群热爱韩漫的资深读者组成，每天关注韩漫行业的最新动态。布丁漫画覆盖恋爱、奇幻、动作、悬疑、搞笑、剧情等全类型韩漫，提供免费全集韩漫资源，致力于打造最优质的韩漫中文阅读社区。
                </p>
                <p className="text-foreground-600 leading-relaxed">
                  布丁漫画核心理念是&ldquo;让每个人都能轻松享受韩漫&rdquo;。我们相信好的内容应该被更多人看到，好的韩漫值得被更多人阅读。无论是韩漫新手还是资深读者，都能在布丁漫画找到属于自己的阅读乐趣。
                </p>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
                {reputationItems.map((item) => (
                  <div key={item.label} className="bg-background-100 rounded-lg p-5 text-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                      <i className={`${item.icon} text-primary-600`}></i>
                    </div>
                    <p className="text-2xl font-bold text-foreground-900">{item.value}</p>
                    <p className="text-xs text-foreground-500 mt-1">{item.label}</p>
                  </div>
                ))}
              </div>

              <div className="mb-8" id="reputation">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">用户口碑</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {reviews.map((review, index) => (
                    <div key={index} className="bg-background-100 rounded-lg p-5">
                      <div className="flex items-center gap-1 mb-3">
                        {[...Array(5)].map((_, i) => (
                          <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                            <i className={`text-accent-500 text-xs ${i < review.rating ? 'ri-star-fill' : 'ri-star-line'}`}></i>
                          </div>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-3">&ldquo;{review.text}&rdquo;</p>
                      <p className="text-xs font-medium text-foreground-900">— {review.name}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8" id="contact">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">联系我们</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">邮箱</p>
                      <p className="text-sm text-foreground-900">contact@budingmanhua.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-wechat-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">微信</p>
                      <p className="text-sm text-foreground-900">布丁漫画官方</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-time-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">工作时间</p>
                      <p className="text-sm text-foreground-900">周一至周五 9:00-18:00</p>
                    </div>
                  </div>
                </div>
                <form className="space-y-4" data-readdy-form="true" onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="about-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="about-name"
                        name="name"
                        type="text"
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="about-email"
                        name="email"
                        type="email"
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-sm text-foreground-700 mb-1.5">留言</label>
                    <textarea
                      id="about-message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <div className="flex items-center gap-3">
                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                      {formStatus === 'submitting' ? '发送中...' : '发送留言'}
                    </button>
                    {formStatus === 'success' && (
                      <span className="text-sm text-secondary-600 font-medium">留言发送成功！我们会尽快回复您。</span>
                    )}
                    {formStatus === 'error' && (
                      <span className="text-sm text-primary-600">{formError}</span>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}